module.exports = __webpack_public_path__ + "img/dollar-square.d476ce63.svg";